module.exports = __webpack_public_path__ + "img/image-01.60a75ac5.jpeg";